import { gql } from "@apollo/client";
import useData from "helpers/useData";
import useMobileLayout from "helpers/useMobileLayout";
import React from "react";

import PotwVideoPlayer, { PotwVideoPlayerFragment } from "./PotwVideoPlayer";
import VideoPlayerDialog from "./VideoPlayerDialog";
import { CloseButton } from "./VideoPlayerDialogFooter";

export default function PotwVideoPlayerDialog({ open, onClose, potwCompetitionId }) {
  const [data] = useData(
    gql`
      query PotwVideoPlayerDialog($potwCompetitionId: ID!) {
        potwCompetition(id: $potwCompetitionId) {
          id
          ...PotwVideoPlayerFragment
        }
      }
      ${PotwVideoPlayerFragment}
    `,
    { potwCompetitionId },
    { skip: !open },
  );
  const mobileLayout = useMobileLayout();

  return (
    <VideoPlayerDialog open={open} onClose={onClose}>
      <PotwVideoPlayer
        potwCompetition={data?.potwCompetition}
        potwCompetitionId={potwCompetitionId}
        // like a reel, a Top 5 video stands alone, so close sits in the header row; mobile has the dialog's X
        headerAction={!mobileLayout && <CloseButton onClose={onClose} />}
      />
    </VideoPlayerDialog>
  );
}
